import { gwGet, gwPost } from '../actionsFactory/gwRequest';
import API_PATH from '../actionsFactory/apiPath';
import createBaseActions, { handleGwData, setPostBody } from '../actionsFactory';
import actionTypes from '../actionsFactory/types';
import makeOrCacheApiReq from '../../utils/apiCache';

const {
  SET_MARGIN_STATUS,
  SET_MARGIN_MODE_TRUE,
  SET_MARGIN_MODE_FALSE,
  SET_MARGIN_AUTO_REPAY,
  SET_MARGIN_BORROW,
  SET_MARGIN_STOPLIMIT_OCO_TAB,
  SET_MARGIN_ASSETS,
  SET_MARGIN_ACCOUNT,
  SET_MARGIN_ACCOUNT_MAX_BORROWABLE,
  SET_MARGIN_COEFF,
  SET_MARGIN_SYMBOLS,
} = actionTypes;

const setMarginStatusAction = createBaseActions(SET_MARGIN_STATUS, 'data');
const setMarginBorrowAction = createBaseActions(SET_MARGIN_BORROW, 'data');
const setMarginAutoRepayAction = createBaseActions(SET_MARGIN_AUTO_REPAY, 'data');
export const setMarginModeTrue = createBaseActions(SET_MARGIN_MODE_TRUE, 'data');
export const setMarginModeFalse = createBaseActions(SET_MARGIN_MODE_FALSE, 'data');
export const setMarginStopLimitOrOCOTab = createBaseActions(SET_MARGIN_STOPLIMIT_OCO_TAB, 'data');
const setMarginAsset = createBaseActions(SET_MARGIN_ASSETS, 'data');
const setMarginAccount = createBaseActions(SET_MARGIN_ACCOUNT, 'data');
export const setMarginAccountMaxBorrowable = createBaseActions(SET_MARGIN_ACCOUNT_MAX_BORROWABLE, 'data');
export const setMarginCoeff = createBaseActions(SET_MARGIN_COEFF, 'data');
export const setMarginSymbols = createBaseActions(SET_MARGIN_SYMBOLS, 'data');

const getErrorMsg = (code = '') => {
  const [mainErr, subErrs = ''] = code.split(':');
  let err = [mainErr];
  subErrs && (err = err.concat(subErrs.split(',')));
  return err.map(str => `exchange-code-${str.trim()}`).join(',');
};

export const setMarginStatus = (status) => async dispatch => {
  dispatch(setMarginStatusAction(status));
};

export const setMarginBorrow = (status, side) => dispatch => {
  const data = { status, side };
  dispatch(setMarginBorrowAction(data));
};

export const setMarginAutoRepay = (status, side) => dispatch => {
  const data = { status, side };
  dispatch(setMarginAutoRepayAction(data));
};

export const fetchMarginSymbols = async (req) => {
  let result = [];
  try {
    const api = API_PATH.MARGIN_SYMBOLS;
    const cacheGetter = () => gwGet(api, {}, req);
    const response = await makeOrCacheApiReq(api, cacheGetter, res => res.success && Array.isArray(res.data));
    result = response.data || [];
  } catch (e) {
    // todo
  }
  return result;
};

export const fetchMarginCoeff = () => async dispatch => {
  let result = {
    normalBar: '2.00000000',
    marginCallBar: '1.30000000',
    forceLiquidationBar: '1.10000000',
  };
  try {
    result = handleGwData(await gwGet(API_PATH.MARGIN_COEFF));
  } catch (e) {
    // noop
  }
  dispatch(setMarginCoeff(result));
};

export const fetchVipInterest = async () => {
  let result = [];
  try {
    result = handleGwData(await gwGet(API_PATH.MARGIN_VIP_INTEREST_RATE));
  } catch (e) {
    // noop
  }
  return result;
};

export const fetchVipInterestAdj = async () => {
  let result = [];
  try {
    result = handleGwData(await gwGet(API_PATH.MARGIN_VIP_INTEREST_RATE_ADJ));
  } catch (e) {
    // noop
  }
  return result;
};

// interestrate api should call at client side!!! fucking
export const fetchInterestRate = () => async (dispatch, getState) => {
  let result = [];
  try {
    result = handleGwData(await gwGet(API_PATH.MARGIN_INTEREST_RATE));
  } catch (error) {
    // noop
  }
  const interestRateMap = result.reduce((a, { asset, interestRate }) => {
    a[asset] = interestRate;
    return a;
  }, {});
  const { marginAccount } = getState();

  dispatch(setMarginAccount({
    ...marginAccount,
    interestRateMap,
  }));
};

export const fetchMarginAssets = req => async dispatch => {
  let assets = [];
  try {
    const api = API_PATH.MARGIN_ALL_ASSET;
    assets = await makeOrCacheApiReq(api, () => gwGet(api, {}, req), res => res.success && Array.isArray(res.data));
    assets = handleGwData(assets);
  } catch (error) {
    // noop
  }

  dispatch(setMarginAsset(assets));
};
export const createMarginAccount = async () => {
  try {
    const { success, code } = await gwPost(API_PATH.MARGIN_ACCOUNT_ENABLE);
    if (!success) {
      throw new Error(getErrorMsg(code));
    }
  } catch (error) {
    throw new Error(error.message);
  }
};

export const fetchMarginAccount = () => async (dispatch, getState) => {
  try {
    let data = await gwGet(API_PATH.MARGIN_ACCOUNT_DETAIL);
    data = handleGwData(data);
    const { marginAccount: { interestRateMap } } = getState();
    dispatch(setMarginAccount({
      ...data,
      interestRateMap,
    }));
  } catch (error) {
    // nothing
  }
};

export const marginTransferIn = async params => {
  try {
    const { success, code } = await gwPost(API_PATH.MARGIN_TRANSFER_IN, setPostBody(params));
    if (!success) {
      throw new Error(getErrorMsg(code));
    }
  } catch (error) {
    throw new Error(error.message);
  }
};
export const marginTransferOut = async params => {
  try {
    const { success, code } = await gwPost(API_PATH.MARGIN_TRANSFER_OUT, setPostBody(params));
    if (!success) {
      throw new Error(getErrorMsg(code));
    }
  } catch (error) {
    throw new Error(error.message);
  }
};

export const fetchMaxTransferOutAmout = async asset => {
  let amout = '0';
  try {
    const result = await gwGet(`${API_PATH.MARGIN_TRANSFER_OUT_AMOUT}?asset=${asset}`);
    amout = handleGwData(result).value;
  } catch (error) {
    // nothing
  }
  return `${amout || 0}`;
};

export const fetchMaxBorrowAmount = async (asset, timeout = 500) => new Promise(resolve => setTimeout(resolve, timeout)
).then(async () => {
  let amout = '0';
  try {
    const result = await gwGet(`${API_PATH.MARGIN_BORROW_AMOUT}?asset=${asset}`);
    amout = handleGwData(result).value;
  } catch (error) {
    // nothing
  }
  return `${amout || 0}`;
});

export const marginBorrow = async params => {
  try {
    const { success, code } = await gwPost(API_PATH.MARGIN_BORROW, setPostBody(params));
    if (!success) {
      throw new Error(getErrorMsg(code));
    }
  } catch (error) {
    throw new Error(error.message);
  }
};

export const marginRepay = async params => {
  try {
    const { success, code } = await gwPost(API_PATH.MARGIN_REPAY, setPostBody(params));
    if (!success) {
      throw new Error(getErrorMsg(code));
    }
  } catch (error) {
    throw new Error(error.message);
  }
};

export const obj2Query = params => Object.keys(params).length > 0
  ? `?${Object.keys(params).reduce((pre, cur) => `${pre}${params[cur] ? `${cur}=${params[cur]}&` : ''}`, '').replace(/&$/, '')}`
  : '';

const fetchBorrowHistory = params => gwGet(`${API_PATH.MARGIN_BORROW_HISTORY}${obj2Query(params)}`);
const fetchRepayHistory = params => gwGet(`${API_PATH.MARGIN_REPAY_HISTORY}${obj2Query(params)}`);
const fetchTransferHistory = params => gwGet(`${API_PATH.MARGIN_TRANSFER_HISTORY}${obj2Query(params)}`);
const fetchInterestHistory = params => {
  params = {
    ...params,
    startTime: Math.floor(params.startTime / 1000),
    endTime: Math.floor(params.endTime / 1000),
  };
  return gwGet(`${API_PATH.MARGIN_INTEREST_HISTORY}${obj2Query(params)}`);
};
const fetchMarginCallHistory = params => gwGet(`${API_PATH.MARGIN_CALL_HISTORY}${obj2Query(params)}`);
const fetchPriceIndexHistory = params => gwGet(`${API_PATH.MARGIN_PRICE_INDEX_HISTORY}${obj2Query(params)}`);

const apiMap = {
  'borrow': fetchBorrowHistory,
  'repayment': fetchRepayHistory,
  'transfer': fetchTransferHistory,
  'interest': fetchInterestHistory,
  'margin-call': fetchMarginCallHistory,
  'price-index': fetchPriceIndexHistory,
};
export const fetchMarginDataSource = async (type, params) => {
  let result = {
    total: 0,
    data: [],
  };
  try {
    const { success, data = [], total = 0 } = await apiMap[type](params);
    if (success) {
      const filterData = data.map((item, index) => ({ idx: index, ...item }));
      result = {
        data: filterData,
        total,
      };
    }
  } catch (error) {
    // noop
  }
  result.data = result.data || [];
  return result;
};

export const fetchAllPriceIndex = async () => {
  let result = {};
  try {
    const { success, data = [] } = await gwGet(`${API_PATH.MARGIN_ALL_PRICE_INDEX}`);
    if (!success) throw new Error();
    result = data.reduce((a, b) => {
      a[b.symbol] = b.price;
      return a;
    }, {});
    result.USDTUSDT = '1.00000000';
    result.BTCBTC = '1.00000000';
  } catch (error) {
    // noop;
  }
  return result;
};

export const validateBar = async params => {
  let rs = {
    allPass: false,
    rows: [],
  };
  try {
    rs = handleGwData(await gwPost(API_PATH.MARGIN_VALIDATE_BAR, setPostBody(params)));
  } catch (error) {
    // noop
  }
  return rs;
};

export const adjustBar = async params => {
  let rs = false;
  let error = '';
  try {
    const { success, code } = await gwPost(API_PATH.MARGIN_ADJUST_BAR, setPostBody(params));
    rs = success;
    error = code;
  } catch (err) {
    // noop
  }
  error !== '051042' && (error = '051998');
  return [rs, error];
};

export const fetchMarginFeeMaxBorrow = async assets => {
  let res = {};
  try {
    res = await gwGet(`${API_PATH.MARGIN_FEE_MAX_BORROW}?assets=${assets}`);
  } catch (err) {
    // noop
  }
  return res;
};

export default {};
